module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery2.cb5edd0d80aea0db5d2ca534a42d533c.png";